module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-johany-1-3e88327166fa821bd3aee7de3cef54a0.jpg";